import { Box, Group, Text } from "@mantine/core"
import { IconMinus, IconPlus, IconZoomOut } from "@tabler/icons-react"
import { ReactNode } from "react"

import { useZoom } from "../../hooks/useZoom"
import classes from "../ScrollArea/ScrollArea.module.css"

interface ZoomContainerProps {
  children: ReactNode
}

export const ZoomContainer = ({ children }: ZoomContainerProps) => {
  const { zoom, handleZoomOut, zoomIndex, handleZoomIn } = useZoom()

  return (
    <Box className={classes.zoomContainer}>
      <Group gap={2} className={classes.zoomToggle}>
        {zoomIndex !== 0 ? (
          <>
            <IconMinus size={16} onClick={handleZoomOut} />
            <IconPlus size={16} onClick={handleZoomIn} />
            <Text size="xs" fw={500}>
              {Math.round(zoom * 100)}%
            </Text>
          </>
        ) : (
          <IconZoomOut size={16} onClick={handleZoomOut} />
        )}
      </Group>

      <Box
        className={classes.zoomedContent}
        style={{
          transform: `scale(${zoom})`,
        }}
      >
        {children}
      </Box>
    </Box>
  )
}
